export const PanelSkeleton = () =>
{
	return <div className="wrapper">
		<div className="animate-pulse flex space-x-4">
			<div className="flex-1">
				<div className="flex justify-between align-center">
					<div className="h-3 bg-disabled rounded w-1/6 mt-2"></div>
					<div className="flex">
						<div className="bg-disabled rounded w-28 h-7 mx-1"></div>
						<div className="bg-disabled rounded w-28 h-7 mx-1"></div>
					</div>
				</div>
				<hr className='border-disabled mb-4'/>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
				<div className="flex align-center !mb-12 !last:mb-0">
					<div className="w-1/2">
						<div className="bg-disabled rounded w-40 h-2 mx-1"></div>
						<div className="bg-disabled rounded w-80 h-3 mx-1 mt-3"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
};


export const SubpanelSkeleton = () =>
{
	return <div className="wrapper">
		<div className="animate-pulse flex space-x-4">
			<div className="flex-1 pb-4">
				<div className="flex justify-between align-center">
					<div className="h-2 bg-disabled rounded w-1/6 mt-2"></div>
					<div className="h-2 bg-disabled rounded w-7 h-7 mx-1"></div>
				</div>
				<hr className='border-disabled'/>
				<div className="h-8 bg-disabled rounded"></div>
				<div className="h-3 my-4 bg-disabled rounded"></div>
				<div className="h-3 my-4 bg-disabled rounded"></div>
				<div className="h-3 bg-disabled rounded"></div>
			</div>
		</div>
	</div>
}

export const DashletSkeleton = () => {
	return <div className="animate-pulse flex space-x-4">
		<div className="rounded-full bg-disabled h-12 w-12 me-5"></div>
		<div className="flex-1 space-y-6 pt-2 pb-4">
			<div className="h-2 bg-disabled rounded"></div>
			<div className="space-y-3">
				<div className="grid grid-cols-3 gap-4">
					<div className="h-2 bg-disabled rounded col-span-2"></div>
					<div className="h-2 bg-disabled rounded col-span-1"></div>
				</div>
				<div className="h-2 bg-disabled rounded"></div>
			</div>
		</div>
	</div>
}

export const BarChartSkeleton = () => {
	return <div className="animate-pulse flex space-x-4">
		<div className="flex gap-4 pt-2 pb-4 w-full items-end">
			<div className="w-10 h-32 bg-disabled rounded grow"></div>
			<div className="w-10 h-56 bg-disabled rounded grow"></div>
			<div className="w-10 h-28 bg-disabled rounded grow"></div>
			<div className="w-10 h-40 bg-disabled rounded grow"></div>
			<div className="w-10 h-20 bg-disabled rounded grow"></div>
			<div className="w-10 h-36 bg-disabled rounded grow"></div>
		</div>
	</div>
}

export const GatewaySkeleton = () => {
	return (
		<div className="wrapper flex justify-center items-center min-h-[200px]">
			<div className="animate-pulse flex justify-center items-center p-5">
				<div role="status">
					<svg
						aria-hidden="true"
						className="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
						viewBox="0 0 100 101"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
							fill="currentColor"
						/>
						<path
							d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
							fill="currentFill"
						/>
					</svg>
					<span className="sr-only"></span>
				</div>
			</div>
		</div>
	);
};
